import React from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import 'react-dadata/dist/react-dadata.css';

// SVG компоненты (остаются без изменений)
const CloseIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L11 11" stroke="black" strokeLinecap="round"/>
    <path d="M11 1L1 11" stroke="black" strokeLinecap="round"/>
  </svg>
);

const CurrentLocationMarker = () => (
  <svg width="30" height="38" viewBox="0 0 30 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.9999 0C6.71544 0 0 6.80501 0 15.2001C0 19.396 1.67774 23.1952 4.39122 25.9456C7.10546 28.6975 13.0293 32.68 13.4043 36.8598C13.5638 37.5043 14.3789 38 14.9999 38C15.6209 38 16.2766 37.5043 16.4362 36.8598C16.811 32.68 22.8943 28.6975 25.6085 25.9456C28.3221 23.1952 30 19.396 30 15.2001C30 6.80501 23.2845 0 14.9999 0Z" fill="white"/>
    <path d="M14.9999 2C7.82005 2 2 8.08869 2 15.6001C2 19.3543 3.45404 22.7536 5.80572 25.2145C8.15806 27.6767 13.6999 31.24 14.0249 34.9798C14.0737 35.5406 14.4617 36 14.9999 36C15.5381 36 15.9261 35.5406 15.9751 34.9798C16.2999 31.24 21.8417 27.6767 24.1941 25.2145C26.5458 22.7536 28 19.3543 28 15.6001C28 8.08869 22.1799 2 14.9999 2Z" fill="#A6DD2F"/>
  </svg>
);

const DeliveryIcon = () => (
  <svg width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.769 7.4816C10.1873 7.13412 8.54519 5.92403 9.60775 4.70204C9.72144 4.5713 9.85442 4.44092 10.0095 4.31251C10.5014 3.90536 11.148 3.75881 11.7852 3.79982C14.267 3.95954 20.9515 5.07423 25.0342 12.2663C25.408 12.9249 25.2664 13.7484 24.7317 14.2847C23.9133 15.1054 22.5124 14.955 21.7791 14.0575C20.0298 11.9168 16.6091 8.54498 11.769 7.4816Z" fill="#F28817"/>
    <path d="M1.08292 26.6217C4.49848 20.0719 7.08440 14.599 8.21026 9.81667C8.37160 9.13139 8.98731 8.63220 9.68646 8.71484C15.0882 9.35334 18.9964 12.6437 20.8432 15.2158C21.109 15.586 21.1482 16.0695 20.9518 16.4807C17.9193 22.8305 9.49929 27.7416 2.31191 28.55C1.26164 28.6681 0.594231 27.5588 1.08292 26.6217Z" fill="#FED221"/>
    <path d="M10.5038 21.0213C9.58675 20.307 8.29048 20.4377 7.60846 21.3133C6.92645 22.1889 7.11694 23.4777 8.03395 24.192C8.95095 24.9063 10.2472 24.7756 10.9292 23.9C11.6113 23.0244 11.4208 21.7355 10.5038 21.0213Z" fill="#F5431D"/>
    <path d="M5.15055 24.4582C4.61378 24.0401 3.85501 24.1167 3.45579 24.6292C3.05657 25.1417 3.16808 25.8961 3.70485 26.3142C4.24162 26.7323 5.00039 26.6558 5.39961 26.1433C5.79883 25.6308 5.68732 24.8763 5.15055 24.4582Z" fill="#F5431D"/>
    <path d="M17.1366 13.9109C16.2196 13.1966 14.9233 13.3274 14.2413 14.203C13.5593 15.0785 13.7498 16.3674 14.6668 17.0817C15.5838 17.796 16.88 17.6652 17.5621 16.7896C18.2441 15.914 18.0536 14.6252 17.1366 13.9109Z" fill="#F5431D"/>
    <path d="M11.0085 11.7296C10.4236 11.274 9.59670 11.3574 9.16165 11.9159C8.72661 12.4744 8.84812 13.2965 9.43306 13.7522C10.018 14.2078 10.8449 14.1244 11.2799 13.5659C11.715 13.0073 11.5934 12.1852 11.0085 11.7296Z" fill="#F5431D"/>
    <path d="M13.5719 15.7112C13.3486 16.5191 14.4561 16.9089 14.8427 18.2625C15.2294 19.6161 13.8648 20.0602 14.464 20.5111C15.3378 21.169 16.5233 19.0619 16.1561 17.7024C15.8203 16.4584 13.8933 14.5474 13.5719 15.7112Z" fill="#5ABF0A"/>
    <path d="M9.64105 18.4861C9.31965 19.2602 8.20693 18.8855 7.06889 19.7141C5.93084 20.5426 6.73266 21.7328 5.98287 21.7191C4.88929 21.6995 5.25243 19.3093 6.37877 18.464C7.40933 17.6905 10.1043 17.3711 9.64105 18.4861Z" fill="#5ABF0A"/>
  </svg>
);

const LocationNotFoundIcon = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.9298 9.21884L7.36249 12.4983C4.85358 13.2749 4.81774 16.8113 7.30873 17.6416L10.2119 18.6093C11.0183 18.8781 11.6515 19.5113 11.9203 20.3178L12.8881 23.2209C13.7184 25.7119 17.2488 25.6701 18.0313 23.1672L21.3108 12.5999C21.956 10.5211 20.0086 8.57370 17.9298 9.21884Z" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const MyAddressesIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.33301 1.33398H5.99967C2.66634 1.33398 1.33301 2.66732 1.33301 6.00065V10.0007C1.33301 13.334 2.66634 14.6673 5.99967 14.6673H9.99967C13.333 14.6673 14.6663 13.334 14.6663 10.0007V8.66732" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.6933 2.0135L5.43992 7.26684C5.23992 7.46684 5.03992 7.86017 4.99992 8.14684L4.71325 10.1535C4.60659 10.8802 5.11992 11.3868 5.84659 11.2868L7.85325 11.0002C8.13325 10.9602 8.52659 10.7602 8.73325 10.5602L13.9866 5.30684C14.8933 4.40017 15.3199 3.34684 13.9866 2.0135C12.6533 0.680168 11.5999 1.10684 10.6933 2.0135Z" stroke="black" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.94043 2.7666C10.3871 4.35993 11.6338 5.6066 13.2338 6.05993" stroke="black" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Delivery = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={17} fill="none">
    <path
      fill="currentColor"
      d="M6.898 3.7a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2ZM4.19 8.757l.528-3.171a1.3 1.3 0 0 1 2.581.213v.074c0 1.264-.174 2.521-.518 3.736a.83.83 0 0 0 .144.743l.355.443c.471.588.864 1.235 1.17 1.923l1.18 2.657a.8.8 0 0 1-1.462.65l-1.18-2.657a7.2 7.2 0 0 0-.87-1.46l-.039-.052-.049-.062-.28-.350a14 14 0 0 0-1-1.11 2 2 0 0 1-.404-.541 1.7 1.7 0 0 1-.156-1.036Zm-2.17 7.584a.82.82 0 0 1-.086-1.164c.686-.794 1.828-2.22 2.425-3.541.071-.158.277-.201.396-.077.232.242.575.617.826.966a.35.35 0 0 1 .03.364c-.487.954-1.789 2.527-2.51 3.367a.77.77 0 0 1-1.082.085Zm6.085-9.859c.014-.160.205-.238.332-.139.62.485.922.553 1.662.56a.8.8 0 0 1 .567 1.366.81.81 0 0 1-.567.241c-.744.008-1.326-.03-1.897-.461a.53.53 0 0 1-.196-.48l.1-1.087ZM3.48 4.79 1.948 4.6a.5.5 0 0 0-.55.39L.489 9.105a.5.5 0 0 0 .427.604l1.533.19a.5.5 0 0 0 .55-.389l.91-4.116a.5.5 0 0 0-.427-.604Z"
    />
    <path stroke="currentColor" strokeLinecap="round" d="M7.697 1.5h1" />
    <path fill="currentColor" d="M5.398 1.5a1.5 1.5 0 1 1 3 0h-3Z" />
  </svg>
)

const Restoran = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13} height={15} fill="none">
    <path
      fill="currentColor"
      d="M11.5.127c-.438 0-3.5.875-3.5 4.813v3.062c0 .966.785 1.75 1.75 1.75h.875v3.5a.874.874 0 1 0 1.75 0V1.002A.874.874 0 0 0 11.5.127ZM1.875.565A.436.436 0 0 0 1.484.13a.435.435 0 0 0-.473.34L.182 4.195a2.407 2.407 0 0 0 2.13 2.92v6.136a.874.874 0 1 0 1.75 0V7.116a2.408 2.408 0 0 0 2.13-2.92L5.365.47A.438.438 0 0 0 4.5.565v3.67a.268.268 0 0 1-.536.021L3.622.526a.435.435 0 0 0-.435-.399.435.435 0 0 0-.434.4l-.34 3.73a.268.268 0 0 1-.536-.022L1.876.564Zm1.32 4.156H3.18l.008-.019.009.02Z"
    />
  </svg>
)

const EditAdres = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 3.987a67.801 67.801 0 0 0-6.68-.334c-1.320 0-2.640.067-3.960.200L2 3.987M5.668 3.313l.147-.873C5.920 1.807 6.000 1.333 7.128 1.333h1.747c1.126 0 1.213.5 1.313 1.114l.147.866M12.567 6.093l-.433 6.713c-.074 1.047-.134 1.860-1.994 1.860H5.860c-1.860 0-1.920-.813-1.993-1.860l-.433-6.713M6.887 11h2.22M6.332 8.333h3.333"
    />
  </svg>
)

// Функция для проверки точки в полигоне
const isPointInPolygon = (point, polygon) => {
  const [x, y] = point;
  let inside = false;
  
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const [xi, yi] = polygon[i];
    const [xj, yj] = polygon[j];
    
    const intersect = ((yi > y) !== (yj > y)) &&
      (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
    
    if (intersect) inside = !inside;
  }
  
  return inside;
};

// Функция для проверки, открыт ли ресторан
const isRestaurantOpen = (worktime) => {
  if (!worktime) return false;
  
  try {
    // Парсим формат "11:00-22:30"
    const [openTimeStr, closeTimeStr] = worktime.split('-');
    if (!openTimeStr || !closeTimeStr) return false;
    
    // Получаем текущее время
    const now = new Date();
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();
    const currentTotalMinutes = currentHours * 60 + currentMinutes;
    
    // Парсим время открытия
    const [openHours, openMinutes] = openTimeStr.split(':').map(Number);
    const openTotalMinutes = openHours * 60 + openMinutes;
    
    // Парсим время закрытия
    const [closeHours, closeMinutes] = closeTimeStr.split(':').map(Number);
    let closeTotalMinutes = closeHours * 60 + closeMinutes;
    
    // Если ресторан работает после полуночи (например, до 02:00)
    if (closeTotalMinutes < openTotalMinutes) {
      closeTotalMinutes += 24 * 60; // Добавляем сутки
    }
    
    // Проверяем, находится ли текущее время в промежутке работы
    return currentTotalMinutes >= openTotalMinutes && currentTotalMinutes <= closeTotalMinutes;
  } catch (error) {
    console.error('Ошибка при парсинге времени работы:', error, worktime);
    return false;
  }
};

class SetLocation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      location: {
        center: [37.588144, 55.733842],
        zoom: 14
      },
      isClient: false,
      MapComponents: null,
      restaurantsArr: props?.restaurants ? Object.values(props.restaurants) : [],
      userZone: null,
      userRestaurant: null,
      selectedAddress: null,
      valueAddress: {},
      key: 1,
      entrance: '',
      intercom: '',
      floor: '',
      apartment: '',
      comment: '',
      tab: `delivery`,
      type: props.deliveryType,
      activeLocation: null,
      findrest: ``,
      isPrivateHouse: false, // Добавлено состояние для переключателя
      errors: {} // Ошибки валидации полей
    }
  }

  componentDidUpdate(prevProps) {
    // Сбрасываем состояние при открытии компонента
    if (this.props.show && !prevProps.show) {
      this.resetState();
    }
  }

  resetState = () => {
    this.setState({
      location: {
        center: [37.588144, 55.733842],
        zoom: 14
      },
      userZone: null,
      userRestaurant: null,
      selectedAddress: null,
      valueAddress: {},
      key: this.state.key + 1,
      entrance: '',
      intercom: '',
      floor: '',
      apartment: '',
      comment: '',
      activeLocation: null, // Сбрасываем активный адрес
      isPrivateHouse: false, // Сбрасываем переключатель
      errors: {} // Сбрасываем ошибки
    }, () => {
      // Заново получаем геолокацию при открытии
      this.getCurrentLocation();
    });
  }

  async componentDidMount() {
    this.setState({ isClient: true })
    
    if (typeof window !== 'undefined') {
      try {
        const {
          YMapComponentsProvider,
          YMap,
          YMapDefaultSchemeLayer,
          YMapDefaultFeaturesLayer,
          YMapMarker,
          YMapFeature
        } = await import('ymap3-components')

        const {
          AddressSuggestions
        } = await import('react-dadata')
        
        this.setState({
          MapComponents: {
            YMapComponentsProvider,
            YMap,
            YMapDefaultSchemeLayer,
            YMapDefaultFeaturesLayer,
            YMapMarker,
            YMapFeature,
            AddressSuggestions
          }
        })
      } catch (error) {
        console.error('Ошибка загрузки карты:', error);
      }
    }

    this.getCurrentLocation();
  }

  getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          // Проверяем, что координаты валидные числа
          if (!isNaN(longitude) && !isNaN(latitude)) {
            this.detectZoneFromCoordinates([longitude, latitude]);
            
            this.setState({
              location: {
                center: [longitude, latitude],
                zoom: 14
              },
              selectedAddress: [longitude, latitude]
            });
          }
        },
        (error) => {
          console.error('Ошибка получения геолокации:', error);
          // Устанавливаем дефолтные координаты при ошибке
          this.setState({
            location: {
              center: [37.588144, 55.733842],
              zoom: 14
            }
          });
        }
      );
    }
  }

  // Добавляем валидацию координат
  validateCoordinates = (coords) => {
    if (!coords || !Array.isArray(coords) || coords.length !== 2) {
      return false;
    }
    const [lon, lat] = coords;
    return !isNaN(lon) && !isNaN(lat) && 
           typeof lon === 'number' && typeof lat === 'number' &&
           lon >= -180 && lon <= 180 && 
           lat >= -90 && lat <= 90;
  }

  detectZoneFromCoordinates = (coords) => {
    // Проверяем валидность координат
    if (!this.validateCoordinates(coords)) {
      console.error('Invalid coordinates:', coords);
      return;
    }

    let foundZone = null;
    let foundRestaurant = null;
    
    for (const restaurant of this.state.restaurantsArr) {
      for (const zone of restaurant.zones) {
        const zoneCoords = zone.geometry.coordinates;
        
        if (zone.geometry.type === 'Polygon') {
          if (isPointInPolygon(coords, zoneCoords[0])) {
            foundZone = zone;
            foundRestaurant = restaurant;
            break;
          }
        }
      }
      if (foundZone) break;
    }
    
    this.setState({
      userZone: foundZone,
      userRestaurant: foundRestaurant
    });
  }

  changeAddressSuggestions = (res) => {
    if (!res || !res.data) return;

    const { data } = res;
    const { geo_lat, geo_lon } = data;
    
    // Проверяем валидность координат
    const lat = parseFloat(geo_lat);
    const lon = parseFloat(geo_lon);
    
    if (isNaN(lat) || isNaN(lon)) {
      console.error('Invalid coordinates from address:', geo_lat, geo_lon);
      return;
    }

    var spErr = false
    if(data?.house == ``) spErr = true
    if(data?.settlement == "Приокские дали (поселок Жерновка)") spErr = true

    if (spErr) {
      this.setState({
        userZone: null,
        userRestaurant: null,
        valueAddress: {},
        key: this.state.key + 1
      });
      
      if (this.validateCoordinates([lon, lat])) {
        this.setState({
          location: {
            center: [lon, lat],
            zoom: 14
          },
          selectedAddress: [lon, lat]
        });
      }
      return;
    }
    
    if (this.validateCoordinates([lon, lat])) {
      this.detectZoneFromCoordinates([lon, lat]);
      
      this.setState({
        valueAddress: res,
        location: {
          center: [lon, lat],
          zoom: 14
        },
        selectedAddress: [lon, lat]
      });
    }
  }

  dadataFindAdress = (geo) => {
    // Проверяем валидность координат
    if (!this.validateCoordinates(geo)) {
      console.error('Invalid coordinates for dadata:', geo);
      return;
    }

    const { key } = this.state;

    axios.post(`https://${window.location.host}/suggestions/geolocate/address`, {
      lon: geo[0],
      lat: geo[1],
      count: 20,
      radius_meters: 80
    }, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    })
    .then((resp) => {
      let result = resp.data;
      if (result.suggestions.length > 0) {
        const validAddresses = result.suggestions.filter(suggestion => {
          const hasHouseNumber = suggestion.data.house;
          return hasHouseNumber;
        });
        
        if (validAddresses.length > 0) {
          const bestAddress = validAddresses[0];
          this.setState({
            key: key + 1
          }, () => {
            this.changeAddressSuggestions(bestAddress);
          });
        } else {
          this.setState({
            userZone: null,
            userRestaurant: null,
            key: key + 1
          });
        }
      } else {
        this.setState({
          userZone: null,
          userRestaurant: null,
          key: key + 1
        });
      }
    })
    .catch((error) => {
      console.error('Ошибка при поиске адреса:', error);
    });
  }

  zoneClick = (event) => {
    const coordinates = event?.coordinates;
    if (this.validateCoordinates(coordinates)) {
      this.dadataFindAdress(coordinates);
    }
  }

  validateRequiredFields = () => {
    const { entrance, floor, apartment, isPrivateHouse } = this.state;
    const errors = {};

    if (!isPrivateHouse) {
      if (!entrance.trim()) errors.entrance = 'Укажите подъезд';
      if (!floor.trim()) errors.floor = 'Укажите этаж';
      if (!apartment.trim()) errors.apartment = 'Укажите квартиру';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  }

  setAdres = () => {
    const { userZone, userRestaurant, selectedAddress, valueAddress, entrance, intercom, floor, apartment, comment, isPrivateHouse } = this.state;
    const { onZoneSelected } = this.props;

    // Проверяем валидность координат перед отправкой
    if (!this.validateCoordinates(selectedAddress)) {
      console.error('Invalid coordinates for address:', selectedAddress);
      return;
    }

    // Валидация обязательных полей для многоэтажных домов
    if (!this.validateRequiredFields()) {
      return;
    }

    const addressData = valueAddress?.data || {};
    const addressString = valueAddress?.value || '';
    const city = addressData.city_with_type || addressData.settlement_with_type || '';
    const street = addressData.street_with_type || '';
    const house = addressData.house || '';

    onZoneSelected({
      isset: true,
      coordinates: selectedAddress,
      restaurantId: userRestaurant?.id || null,
      zoneId: userZone?.properties?.zone_id || null,
      address: addressString,
      city: city,
      street: street,
      house: house,
      entrance: entrance,
      intercom: intercom,
      floor: floor,
      apartment: apartment,
      comment: comment,
      isPrivateHouse: isPrivateHouse // Добавляем информацию о частном доме
    });
  }

  // Функция для выбора адреса из списка
  selectLocation = (location) => {
    this.setState({ activeLocation: location.address });
    
    // Обновляем карту и зону доставки для выбранного адреса
    if (location.coordinates && this.validateCoordinates(location.coordinates)) {
      this.detectZoneFromCoordinates(location.coordinates);
      
      this.setState({
        location: {
          center: location.coordinates,
          zoom: 14
        },
        selectedAddress: location.coordinates
      });
    }
  }

  // Функция для удаления адреса
  handleDeleteLocation = (address) => {
    const { deleteLocation, locations } = this.props;
    const { activeLocation } = this.state;
    
    deleteLocation(address);
    
    // Если удаляем активный адрес, выбираем первый из оставшихся
    if (activeLocation === address && locations.length > 1) {
      const remainingLocations = locations.filter(loc => loc.address !== address);
      if (remainingLocations.length > 0) {
        this.selectLocation(remainingLocations[0]);
      } else {
        // Если адресов не осталось, сбрасываем активный
        this.setState({ activeLocation: null });
      }
    }
  }

  // Функция для подтверждения выбранного адреса
  confirmSelectedAddress = () => {
    const { activeLocation, userZone } = this.state;
    const { locations, onZoneSelected } = this.props;
    
    if (!activeLocation || !userZone) return;
    
    // Находим выбранный адрес в списке
    const selectedLocation = locations.find(loc => loc.address === activeLocation);
    
    if (selectedLocation) {
      onZoneSelected({
        isset: true,
        coordinates: selectedLocation.coordinates,
        restaurantId: this.state.userRestaurant?.id || null,
        zoneId: this.state.userZone?.properties?.zone_id || null,
        address: selectedLocation.address,
        city: selectedLocation.city || '',
        street: selectedLocation.street || '',
        house: selectedLocation.house || '',
        entrance: selectedLocation.entrance || '',
        intercom: selectedLocation.intercom || '',
        floor: selectedLocation.floor || '',
        apartment: selectedLocation.apartment || '',
        comment: selectedLocation.comment || ''
      });
    }
  }

  handleInputChange = (field, value) => {
    // Очищаем ошибку для этого поля при вводе
    this.setState(prevState => ({
      [field]: value,
      errors: {
        ...prevState.errors,
        [field]: undefined
      }
    }));
  }

  // Обработчик переключателя частного дома
  handlePrivateHouseToggle = (checked) => {
    this.setState({ 
      isPrivateHouse: checked,
      apartment: checked ? '1' : '' // Устанавливаем значение "1" при включении, очищаем при выключении
    });
  }

  setTab = ( tab ) => {
    this.setState({ tab: tab })
  }

  findNearestRestaurant = () => {
    const { location, restaurantsArr } = this.state;
    
    if (!this.validateCoordinates(location.center) || !restaurantsArr?.length) {
      return;
    }

    let nearestRestaurant = null;
    let minDistance = Infinity;

    restaurantsArr.forEach(restaurant => {
      if (this.validateCoordinates(restaurant.coords)) {
        const distance = this.calculateDistance(
          location.center[1], // lat
          location.center[0], // lon
          restaurant.coords[1], // lat
          restaurant.coords[0]  // lon
        );
        
        if (distance < minDistance) {
          minDistance = distance;
          nearestRestaurant = restaurant;
        }
      }
    });

    if (nearestRestaurant) {
      // Обновляем карту
      this.setState({
        location: {
          center: nearestRestaurant.coords,
          zoom: 14
        },
        findrest: nearestRestaurant.adres || '' // Заполняем поле адресом
      });
    }
  }

  calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Радиус Земли в км
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    const distance = R * c; // Расстояние в км
    return distance;
  }

  deg2rad = (deg) => {
    return deg * (Math.PI/180);
  }

  render() {
    const { show, change, assets_path, showUsloviyaWin, type, locations, changeDeliveryType, setPickupRest } = this.props;
    const { tab, location, isClient, MapComponents, restaurantsArr, userZone, selectedAddress, valueAddress, key, entrance, intercom, floor, apartment, comment, activeLocation, findrest, isPrivateHouse, errors } = this.state;
    
    if (!show) return null;

    if (!isClient || !MapComponents) {
      return <div className="flex items-center justify-center">Загрузка карты...</div>;
    }

    const {
      YMapComponentsProvider,
      YMap,
      YMapDefaultSchemeLayer,
      YMapDefaultFeaturesLayer,
      YMapMarker,
      YMapFeature,
      AddressSuggestions
    } = MapComponents;

    // Проверяем валидность координат перед рендерингом карты
    const safeLocation = this.validateCoordinates(location.center) ? location : {
      center: [37.588144, 55.733842]
    };

    return (
      <YMapComponentsProvider apiKey="8cf8bafe-d3f4-4025-ae81-5f6ee929a3d1">
        <div className='fixed z-50 top-0 left-0 bottom-0 right-0 w-[100%] overflow-x-hidden bg-cover bg-center bg-no-repeat tracking-tighter' style={{
            backgroundImage: `url(/${assets_path}/images/welcome_bg.svg)`
          }}>
          <div className="font-inter relative p-0 h-[100%]">
            <div className='absolute top-0 left-0 right-0 px-[10px] pt-[29px] flex justify-between items-center z-20 gap-[5px]'>
              <button
                onClick={() => change(false)}
                className="w-[40px] h-[40px] rounded-full bg-white flex items-center justify-center flex-none"
              >
                <CloseIcon />
              </button>
              {type == `delivery` ?
                <div className='h-[40px] bg-[#F6F6F6] flex items-center justify-between rounded-full cursor-pointer gap-[3px]'>
                  <div className='w-[148px] h-[40px] flex-1 flex items-center justify-center gap-[6px] font-[14px] bg-[#5A91FF] text-white rounded-full'>
                    <Delivery />
                    <div>Доставка</div>
                  </div>
                  <div onClick={() => changeDeliveryType(`pickup`)} className='w-[148px] h-[40px] flex-1 flex items-center justify-center gap-[6px] font-[14px] text-dark rounded-full cursor-pointer'>
                    <Restoran />
                    <div>Самовывоз</div>
                  </div>
                </div>
              :
                <div className='h-[40px] bg-[#F6F6F6] flex items-center justify-between rounded-full cursor-pointer gap-[3px]'>
                  <div onClick={() => changeDeliveryType(`delivery`)} className='w-[148px] h-[40px] flex-1 flex items-center justify-center gap-[6px] font-[14px] text-dark rounded-full cursor-pointer'>
                    <Delivery />
                    <div>Доставка</div>
                  </div>
                  <div className='w-[148px] h-[40px] flex-1 flex items-center justify-center gap-[6px] font-[14px] bg-[#5A91FF] text-white rounded-full'>
                    <Restoran />
                    <div>Самовывоз</div>
                  </div>
                </div>
              }
              <div className="w-[40px] h-[40px] flex-none" />
            </div>
            <div className="w-full flex flex-col items-center justify-center h-[100%]">
              <div className="w-full z-10 flex-1">
                <YMap location={safeLocation}>
                  <YMapDefaultSchemeLayer />
                  <YMapDefaultFeaturesLayer />
                  
                  {type == `delivery` ?
                    <>
                      {this.validateCoordinates(location.center) && (
                        <YMapMarker coordinates={location.center}>
                          <div className="mt-[-38px] ml-[-15px] cursor-pointer">
                            <CurrentLocationMarker />
                          </div>
                        </YMapMarker>
                      )}
                      {this.validateCoordinates(selectedAddress) && (
                        <YMapMarker coordinates={selectedAddress}>
                          <div className="mt-[-38px] ml-[-15px] cursor-pointer">
                            <CurrentLocationMarker />
                          </div>
                        </YMapMarker>
                      )}
                      {restaurantsArr?.map((restaurant) => (
                        restaurant?.zones.map((zone) => (
                          <YMapFeature
                            key={zone.properties.zone_id}
                            geometry={zone.geometry}
                            style={{
                              stroke: [{
                                color: zone.properties.stroke,
                                width: 1
                              }],
                              fill: zone.properties.fill
                            }}
                            onClick={(object, event) => this.zoneClick(event)}
                          />
                        ))
                      ))}
                    </>
                  :
                    <>
                      {restaurantsArr?.map((restaurant) => (
                        <>
                          {this.validateCoordinates(restaurant?.coords) && (
                            <YMapMarker coordinates={restaurant?.coords} onClick={() => setPickupRest(restaurant?.id)} >
                              <div className="mt-[-38px] ml-[-15px] cursor-pointer">
                                <CurrentLocationMarker />
                              </div>
                            </YMapMarker>
                          )}
                        </>
                      ))}
                    </>
                  }

                </YMap>
              </div>
              
              {type == `delivery` ?
                <>
                  {tab == `delivery` &&
                    <div className='z-20 w-[100%] h-[0px] flex justify-center items-end'>
                      <div className='bg-white rounded-tl-[25px] rounded-tr-[25px] mt-[-25px] min-h-[315px] px-[15px] pt-[19px] flex-none w-[100%] max-w-[600px] relative'>
                        <div className='absolute w-[100%] h-[65px] top-[-75px] left-0 flex gap-[5px] px-[10px]'>
                          {userZone && (
                            <>
                              <div className='w-[48px] h-[65px] bg-[#5A91FF] rounded-[25px] flex items-center justify-center'>
                                <DeliveryIcon />
                              </div>
                              <div className="flex-1 w-[48px] bg-[#5A91FF] px-[15px] py-[13px] rounded-[25px]">
                                <div className="text-[16px] font-semibold text-white tracking-tighter">Доставим на ваш адрес
                                  {userZone.properties?.time_max > 0 &&
                                    <>за ~{userZone.properties?.time_max} мин</>
                                  }
                                </div>
                                <div onClick={() => showUsloviyaWin()} className="text-[12px] font-normal text-white cursor-pointer tracking-tighter">Нажмите для просмотра условий доставки {'>'}</div>
                              </div>
                            </>
                          )}
                          {!userZone && (
                            <>
                              <div className='w-[48px] h-[65px] bg-[#F87605] rounded-[25px] flex items-center justify-center'>
                                <LocationNotFoundIcon />
                              </div>
                              <div className="flex-1 w-[48px] bg-[#F87605] px-[13px] py-[7px] rounded-[25px]">
                                <div className="text-[18px] font-semibold text-white tracking-tighter">Не смогли найти вас на карте</div>
                                <div className="text-[14px] font-normal text-[#FFFFFF99] tracking-tighter">Пожалуйста, укажите адрес вручную</div>
                              </div>
                            </>
                          )}
                        </div>
                        <div className='flex justify-between items-center mb-4'>
                          <div className='text-[22px] font-semibold text-black tracking-tighter'>Куда доставить?</div>
                          <div onClick={() => this.setTab('locations')} className='flex items-center px-[12px] py-[7px] bg-[#F6F6F6] rounded-full cursor-pointer'>
                            <MyAddressesIcon />
                            <div className='text-[16px] font-medium text-black ms-[6px] tracking-tighter'>Мои адреса</div>
                          </div>
                        </div>
                        <div className='mb-[5px] text-[12px]'>Начните вводить ваш адрес и выберите 1 из предложенных вариантов</div>
                        <AddressSuggestions
                          key={key}
                          token="a77adcda8e7462f12053d88af8ddde5b888d252d"
                          filterLanguage="ru"
                          name="addr"
                          placeholder="Адрес"
                          selectOnBlur={false}
                          hintText='Укажите ваш адрес с улицей и номером дома'
                          filterLocations={[
                            { region: 'Москва' },
                            { region: 'Московская' }
                          ]}
                          value={valueAddress}
                          onChange={this.changeAddressSuggestions}
                          defaultQuery={``}
                          inputProps={{
                            placeholder: 'Город, улица и дом',
                            className: "w-[100%] h-[40px] bg-[#F6F6F6] border-0 rounded-full mb-[10px] px-[15px]"
                          }}
                          containerClassName="relative"
                          count="4"
                          url={`https://${window.location.host}/suggestions/suggest/address`}
                          minChars="7"
                        />

                        {!isPrivateHouse && (
                          <div className='flex justify-between align-middle gap-[10px] mb-[10px]'>
                            <div className="flex-1 relative">
                              <input
                                type="text"
                                placeholder="Подъезд"
                                value={entrance}
                                onChange={(e) => this.handleInputChange('entrance', e.target.value)}
                                className={`h-[40px] w-[100%] bg-[#F6F6F6] border-0 rounded-full px-[15px] ${errors.entrance ? 'border-2 border-red-500 bg-red-50' : ''}`}
                              />
                              {errors.entrance && <div className="text-red-500 text-[11px] mt-[2px] px-[15px]">{errors.entrance}</div>}
                            </div>
                            <input
                              type="text"
                              placeholder="Домофон"
                              value={intercom}
                              onChange={(e) => this.handleInputChange('intercom', e.target.value)}
                              className="h-[40px] w-[168px] bg-[#F6F6F6] border-0 rounded-full px-[15px] flex-1"
                            />
                          </div>
                        )}
                        {!isPrivateHouse && (
                          <div className='flex justify-between align-middle gap-[10px] mb-[10px]'>
                            <div className="flex-1 relative">
                              <input
                                type="text"
                                placeholder="Этаж"
                                value={floor}
                                onChange={(e) => this.handleInputChange('floor', e.target.value)}
                                className={`h-[40px] w-[100%] bg-[#F6F6F6] border-0 rounded-full px-[15px] ${errors.floor ? 'border-2 border-red-500 bg-red-50' : ''}`}
                              />
                              {errors.floor && <div className="text-red-500 text-[11px] mt-[2px] px-[15px]">{errors.floor}</div>}
                            </div>
                            <div className="flex-1 relative">
                              <input
                                type="text"
                                placeholder="Квартира"
                                value={apartment}
                                onChange={(e) => this.handleInputChange('apartment', e.target.value)}
                                className={`h-[40px] w-[100%] bg-[#F6F6F6] border-0 rounded-full px-[15px] ${errors.apartment ? 'border-2 border-red-500 bg-red-50' : ''}`}
                              />
                              {errors.apartment && <div className="text-red-500 text-[11px] mt-[2px] px-[15px]">{errors.apartment}</div>}
                            </div>
                          </div>
                        )}

                        {/* Переключатель частного дома */}
                        <div className="flex items-center justify-end gap-[5px] mb-3">
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="sr-only peer"
                              checked={isPrivateHouse}
                              onChange={(e) => this.handlePrivateHouseToggle(e.target.checked)}
                            />
                            <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-[#5A91FF]"></div>
                          </label>
                          <span className="text-[14px] font-medium text-gray-700">Частный дом</span>
                        </div>

                        <input 
                          type="text" 
                          placeholder="Комментарий" 
                          name='comment'
                          value={comment}
                          onChange={(e) => this.handleInputChange('comment', e.target.value)}
                          className="w-[100%] h-[40px] bg-[#F6F6F6] border-0 rounded-full px-[15px] mb-[10px]" 
                        />

                        <button
                          className="text-[16px] font-inter w-[100%] h-10 rounded-full mb-2 bg-[#5A91FF] text-white disabled:bg-[#5A91FF] disabled:text-[#FFFFFF80] disabled:opacity-50"
                          disabled={!userZone || (!isPrivateHouse && (!entrance.trim() || !floor.trim() || !apartment.trim()))}
                          onClick={this.setAdres}
                        >
                          Доставить на этот адрес
                        </button>
                      </div>
                    </div>
                  }
                  {tab == `locations` &&
                    <div className='z-20 w-[100%] h-[0px] flex justify-center items-end'>
                      <div className='bg-white rounded-tl-[25px] rounded-tr-[25px] mt-[-25px] min-h-[315px] px-[15px] pt-[19px] flex-none w-[100%] max-w-[600px] relative'>
                        <div className='absolute w-[100%] h-[65px] top-[-75px] left-0 flex gap-[5px] px-[10px]'>
                          {userZone && (
                            <>
                              <div className='w-[48px] h-[65px] bg-[#5A91FF] rounded-[25px] flex items-center justify-center'>
                                <DeliveryIcon />
                              </div>
                              <div className="flex-1 w-[48px] bg-[#5A91FF] px-[15px] py-[13px] rounded-[25px]">
                                <div className="text-[16px] font-semibold text-white tracking-tighter">Доставим на ваш адрес
                                  {userZone.properties?.time_max > 0 &&
                                    <>за ~{userZone.properties?.time_max} мин</>
                                  }
                                </div>
                                <div onClick={() => showUsloviyaWin()} className="text-[12px] font-normal text-white cursor-pointer tracking-tighter">Нажмите для просмотра условий доставки {'>'}</div>
                              </div>
                            </>
                          )}
                          {!userZone && (
                            <>
                              <div className='w-[48px] h-[65px] bg-[#F87605] rounded-[25px] flex items-center justify-center'>
                                <LocationNotFoundIcon />
                              </div>
                              <div className="flex-1 w-[48px] bg-[#F87605] px-[13px] py-[7px] rounded-[25px]">
                                <div className="text-[18px] font-semibold text-white tracking-tighter">Не смогли найти вас на карте</div>
                                <div className="text-[14px] font-normal text-[#FFFFFF99] tracking-tighter">Пожалуйста, укажите адрес вручную</div>
                              </div>
                            </>
                          )}
                        </div>
                        <div className='flex justify-between items-center mb-4'>
                          <div className='text-[22px] font-semibold text-black tracking-tighter'>Мои адреса</div>
                          <div className='flex items-center px-[12px] py-[7px] bg-[#F6F6F6] rounded-full cursor-pointer'>
                            <MyAddressesIcon />
                            <div onClick={() => this.setTab(`delivery`)} className='text-[16px] font-medium text-black ms-[6px] tracking-tighter'>Новый адрес</div>
                          </div>
                        </div>
                        <div className='max-h-[175px] overflow-y-auto mb-[10px]'>
                        {locations
                          .sort((a, b) => (a?.address || '').localeCompare(b?.address || ''))
                          .map((elm, k) => (
                          <div 
                            key={k} 
                            className='bg-[#F6F6F6] rounded-full p-[5px] flex items-center justify-between gap-[8px] mb-[5px] cursor-pointer'
                            onClick={() => this.selectLocation(elm)}
                          >
                            {activeLocation == elm?.address ?
                              <div className='flex-none ms-[5px] w-[16px] h-[16px] rounded-full bg-[#5A91FF59] flex items-center justify-center'>
                                <div className='w-[10px] h-[10px] rounded-full bg-[#5A91FF]' />
                              </div>
                            :
                              <div className='flex-none ms-[5px] w-[16px] h-[16px] rounded-full bg-[#BEBEBE59] flex items-center justify-center'>
                                <div className='w-[10px] h-[10px] rounded-full bg-[#BEBEBE]' />
                              </div>
                            }
                            <div className='text-black text-[16px] font-semibold me-auto'>{elm?.address}</div>
                            <div 
                              onClick={(e) => {
                                e.stopPropagation(); // Предотвращаем всплытие события
                                this.handleDeleteLocation(elm?.address);
                              }} 
                              className='flex-none w-[30px] h-[30px] rounded-full bg-white flex items-center justify-center'
                            >
                              <EditAdres />
                            </div>
                          </div>
                        ))}
                        </div>

                        <button
                          className="text-[16px] font-inter w-[100%] h-10 rounded-full mb-2 bg-[#5A91FF] text-white disabled:bg-[#5A91FF] disabled:text-[#FFFFFF80] disabled:opacity-50"
                          disabled={!userZone || !activeLocation}
                          onClick={this.confirmSelectedAddress}
                        >
                          Доставить на этот адрес
                        </button>
                      </div>
                    </div>
                  }
                </>
                :
                <div className='z-20 w-[100%] h-[0px] flex justify-center items-end'>
                  <div className='bg-white rounded-tl-[25px] rounded-tr-[25px] min-h-[315px] px-[15px] pt-[19px] flex-none w-[100%] max-w-[600px] relative'>
                    <div className='text-black text-[22px] font-semibold text-center mb-[10px]'>Рестораны на карте</div>
                    <input 
                      name="find_rest"
                      type="text" 
                      placeholder="Найти ресторан" 
                      value={findrest}
                      onChange={(e) => this.handleInputChange('findrest', e.target.value)}
                      className="w-[100%] h-[40px] bg-[#F6F6F6] border-0 rounded-full px-[15px] mb-[10px]" 
                    />
                    {restaurantsArr
                      ?.filter(restaurant => 
                        restaurant?.adres?.toLowerCase().includes(findrest?.toLowerCase()) ||
                        restaurant?.name?.toLowerCase().includes(findrest?.toLowerCase())
                      )
                      ?.map((restaurant) => {
                        const isOpen = isRestaurantOpen(restaurant?.worktime);
                        
                        return (
                          <div 
                            key={restaurant.id} 
                            onClick={() => setPickupRest(restaurant?.id)} 
                            className='flex items-center justify-start gap-[10px] cursor-pointer mb-3'
                          >
                            <div 
                              className="inset-0 bg-cover bg-center bg-no-repeat w-[65px] h-[65px] rounded-[15px]"
                              style={{
                                backgroundImage: `url(${restaurant?.image})`
                              }}
                            />
                            <div>
                              <div className='text-[#00000099] text-[14px] font-normal mb-[2px]'>{restaurant?.name}</div>
                              <div className='text-black text-[18px] font-semibold me-auto mb-[2px]'>{restaurant?.adres}</div>
                              <div className='flex items-center gap-[5px]'>
                                <div className='text-[#00000099] text-[12px] font-normal'>{restaurant?.worktime}</div>
                                {isOpen ? (
                                  <div className='bg-[#A6DD2F] rounded-full px-[8px] py-[3px] text-white text-[12px] font-medium'>открыто</div>
                                ) : (
                                  <div className='bg-[#F87605] rounded-full px-[8px] py-[3px] text-white text-[12px] font-medium'>закрыто</div>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    <button
                      className="mt-[15px] text-[16px] font-inter w-[100%] h-10 rounded-full mb-2 bg-[#5A91FF] text-white disabled:bg-[#5A91FF] disabled:text-[#FFFFFF80] disabled:opacity-50"
                      onClick={this.findNearestRestaurant}
                    >
                      Найти ближайший ресторан
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </YMapComponentsProvider>
    );
  }
}

SetLocation.propTypes = {
  assets_path: PropTypes.string,
  show: PropTypes.bool,
  change: PropTypes.func,
  restaurants: PropTypes.object,
  onZoneSelected: PropTypes.func,
  deliveryPrices: PropTypes.array,
  type: PropTypes.string,
  locations: PropTypes.array,
  deleteLocation: PropTypes.func,
  changeDeliveryType: PropTypes.func,
  setPickupRest: PropTypes.func,
  showUsloviyaWin: PropTypes.func
}

export default SetLocation;